// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2iIkp","title":"AfterFrontImage_title__3epmd"};